import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';

@Component({
  selector: 'app-taux-remplissage-select',
  templateUrl: './taux-remplissage-select.component.html',
  styleUrls: ['./taux-remplissage-select.component.css']
})
export class TauxRemplissageSelectComponent implements OnInit {
  public tauxRemplissageList: string[];

  @Input() width: number;
  @Input() disabled: boolean = false;
  @Input() niveauRemplissage: number;
  @Output() niveauRemplissageChange = new EventEmitter<number>();

  @Input() cell: any;

  InitValue = null;

  constructor(private panelLayoutService: PanelLayoutService) {
    // TRANSLATIONS
    this.panelLayoutService.LoadTranslation().subscribe(() => {
      this.tauxRemplissageList = this.panelLayoutService.GetTauxRemplissageSelection();
    });
  }

  ngOnInit() {
    if(this.niveauRemplissage != null) {
      this.InitValue = JSON.parse(JSON.stringify(this.niveauRemplissage));
    }
  }

  updateInfo(event) {
    //this.tauxRemplissageValue = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.typeDechetRWId;
    if (!!this.cell && this.InitValue != this.niveauRemplissage) {
      this.cell.setValue(this.niveauRemplissage);
    }
    this.niveauRemplissageChange.emit(this.niveauRemplissage);
  }

}
